import { unknown } from './unknown';
export var embedCard = function embedCard(node) {
  if (!node.attrs.url) {
    return unknown(node);
  }
  return "[".concat(node.attrs.url, "|").concat(node.attrs.url, "|smart-embed]");
};